import { render, staticRenderFns } from "./Receta.vue?vue&type=template&id=024783ef&"
import script from "./Receta.vue?vue&type=script&lang=js&"
export * from "./Receta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports